<template>
  <el-dialog
    :model-value="modelValue"
    :title="dialogTitle"
    width="420px"
    append-to-body
    align-center
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <p class="upgrade-dialog-desc">{{ dialogDesc }}</p>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="$emit('update:modelValue', false)">閉じる</el-button>
        <el-button
          type="primary"
          :disabled="!contactEnabled"
          :title="contactEnabled ? '' : 'お問い合わせ先が未設定です'"
          @click="handleContact"
        >
          お問い合わせ
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { getContactEmail, isContactEmailConfigured } from '@/utils/contact.js'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  // 'date'：過去日付選択の制限／'region'：地域絞り込みの制限
  scenario: {
    type: String,
    default: 'date',
  },
})

defineEmits(['update:modelValue'])

// シナリオ別の文言（無料版の制限説明。表現はプロダクト確定次第で調整可）
const COPY = {
  date: {
    title: '過去日付の閲覧は有料プラン限定です',
    desc: '無料版では本日分・全国のデータのみご覧いただけます。過去日付の興行データを閲覧するには、有料プランへのアップグレードが必要です。ご興味がございましたら、お気軽にお問い合わせください。',
  },
  region: {
    title: '地域別データは有料プラン限定です',
    desc: '無料版では全国データのみご覧いただけます。都道府県など地域別の興行データを閲覧するには、有料プランへのアップグレードが必要です。ご興味がございましたら、お気軽にお問い合わせください。',
  },
}

const dialogTitle = computed(() => COPY[props.scenario]?.title ?? COPY.date.title)
const dialogDesc = computed(() => COPY[props.scenario]?.desc ?? COPY.date.desc)
const contactEnabled = computed(() => isContactEmailConfigured())

function handleContact() {
  if (!contactEnabled.value) return
  window.location.href = `mailto:${getContactEmail()}`
}
</script>

<style scoped lang="less">
.upgrade-dialog-desc {
  margin: 0;
  color: var(--text-secondary, #4a4a4a);
  font-size: 14px;
  line-height: 1.7;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
